"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _redux = require("redux");

var _reactRouterRedux = require("react-router-redux");

var SubscriptionsReducers = _interopRequireWildcard(require("./SubscriptionsReducers"));

var SettingsReducers = _interopRequireWildcard(require("./SettingsReducer"));

var DynosReducers = _interopRequireWildcard(require("./DynosReducer"));

var DynosEditorReducers = _interopRequireWildcard(require("./DynosEditorReducer"));

var CanSpamSettingsReducers = _interopRequireWildcard(require("./CanSpamSettingsReducer"));

var _portalStatus = _interopRequireDefault(require("EmailData/reducers/portalStatus"));

var ScopesReducers = _interopRequireWildcard(require("./ScopesReducer"));

var UsersReducer = _interopRequireWildcard(require("./UsersReducer"));

var TeamsReducer = _interopRequireWildcard(require("./TeamsReducer"));

var EmailSubscriptionReducer = _interopRequireWildcard(require("./EmailSubscriptionReducer"));

var GatesReducers = _interopRequireWildcard(require("./GatesReducer"));

var DynoDetailsReducer = _interopRequireWildcard(require("./DynoDetailsReducer"));

var ContactPropertiesReducer = _interopRequireWildcard(require("./ContactPropertiesReducer"));

var UserReducer = _interopRequireWildcard(require("./UserReducer"));

var _Notifications = _interopRequireDefault(require("ReduxMessenger/reducers/Notifications"));

var PortalReducer = _interopRequireWildcard(require("./PortalReducer"));

var LegalConsentDefaultSettingsReducer = _interopRequireWildcard(require("./LegalConsentDefaultSettingsReducer"));

var SalesforceCampaignsReducer = _interopRequireWildcard(require("./SalesforceCampaigns"));

var GoToWebinarReducer = _interopRequireWildcard(require("./GoToWebinar"));

var HubSettingsReducer = _interopRequireWildcard(require("./HubSettingsReducer"));

var LeadFlowDashBoardReducer = _interopRequireWildcard(require("./LeadFlowDashBoardReducer"));

var TopicClustersReducer = _interopRequireWildcard(require("./TopicClusters"));

var DynoRevisionsReducer = _interopRequireWildcard(require("./DynoRevisionsReducer"));

var RouterReducer = {
  router: _reactRouterRedux.routerReducer
};
var rootReducer = (0, _redux.combineReducers)((0, _extends2.default)({}, CanSpamSettingsReducers, ContactPropertiesReducer, DynoDetailsReducer, DynosEditorReducers, DynosReducers, GatesReducers, RouterReducer, ScopesReducers, SettingsReducers, SubscriptionsReducers, UserReducer, UsersReducer, TeamsReducer, EmailSubscriptionReducer, PortalReducer, LegalConsentDefaultSettingsReducer, SalesforceCampaignsReducer, GoToWebinarReducer, HubSettingsReducer, LeadFlowDashBoardReducer, TopicClustersReducer, DynoRevisionsReducer, {
  emailStatus: _portalStatus.default,
  notifications: _Notifications.default
}));
var _default = rootReducer;
exports.default = _default;
module.exports = exports.default;